"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const contexts_1 = require("@App/contexts");
const TablesForm_1 = __importDefault(require("@Components/ViewWork/Table/TablesForm"));
const GroupedTable = (0, react_1.forwardRef)((props, ref) => {
    const { tableInfo, icon, validationSchema, rowsAreValid } = props;
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const isCurrentRightsholder = rightsholderStore.memberSummary.name === tableInfo[0].groupedBy;
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(isCurrentRightsholder);
    const isNumber = typeof tableInfo[0].groupedValue === 'number';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'grouped-table-header', ref: isCurrentRightsholder ? ref : undefined },
            react_1.default.createElement("div", { className: 'display left' },
                react_1.default.createElement("img", { className: 'icon', src: icon }),
                react_1.default.createElement("p", { className: 'grouped-name' }, tableInfo[0].groupedBy),
                react_1.default.createElement("p", { className: 'owner-indicator' }, isCurrentRightsholder && ' - YOU')),
            react_1.default.createElement("div", { className: 'display right' },
                isNumber ? Number(tableInfo[0].groupedValue).toFixed(2) + '%' : tableInfo[0].groupedValue,
                react_1.default.createElement("div", { className: 'expand-publisher', onClick: () => {
                        setIsExpanded(!isExpanded);
                    } },
                    react_1.default.createElement("img", { src: isExpanded ? common_1.ICONS.chevron_drop_up : common_1.ICONS.chevron_drop_down, alt: 'expand-cell-toggle' })))),
        isExpanded && (react_1.default.createElement(TablesForm_1.default, { className: 'publishers-table', tableInfos: tableInfo, validationSchema: validationSchema, rowsAreValid: (isValid) => isCurrentRightsholder && rowsAreValid(isValid), hideAddButton: true }))));
});
GroupedTable.displayName = 'GroupedTable';
exports.default = GroupedTable;
